<template lang="pug">
#tasks-list
  .table-view
    .table-view-header
      .table-view-header-title
        h3 Tareas
      .table-view-header-actions
        b-btn(@click="showCreateModal()" size="sm" variant="secondary") + Nuevo
    b-table(:fields="fields" :items="tableItems" head-row-variant="light-primary" responsive)
      template(v-slot:cell(Acciones)="data")
        .table-actions
          b-button(:to="{ name: 'TaskDetail', params: { taskId: data.value.task.id } }" size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'edit']" size="lg")
          b-button(@click="showDeleteModal(data.value.task)", size="sm", variant="light" style="color: #7F828F")
            font-awesome-icon(:icon="['far', 'trash-alt']" size="lg")
  //- Modales
  b-modal(v-model="showCreate", :hide-footer="true", title="Crear Tarea" no-close-on-backdrop)
    create-edit-form(v-if="showCreate", action="create", :hideModal="hideCreateModal", :makeToast="makeToast")
    
  b-modal(v-model="showDelete", :hide-footer="true", title="Eliminar Tarea" no-close-on-backdrop)
    delete-task(v-if="showDelete", :hideModal="hideDeleteModal", :selectedTask="selectedTask", :makeToast="makeToast")

  b-modal(v-model="showEdit", :hide-footer="true", title="Editar Tarea" no-close-on-backdrop)
    create-edit-form(v-if="showEdit", :hideModal="hideEditModal", :selectedTask="selectedTask", :makeToast="makeToast")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import CreateEditForm from './CreateEditForm';
import DeleteTask from './DeleteTask';

export default {
  components: {
    CreateEditForm,
    DeleteTask
  },
  data() {
    return {
      showCreate: false,
      showDelete: false,
      showEdit: false,
      selectedTask: null,
      fields: [
        {
          key: 'Nombre',
          sortable: true
        },
        {
          key: 'Responsable',
          sortable: true
        },
        {
          key: 'Día de vencimiento',
          sortable: true
        },
        {
          key: 'Acciones',
        }
      ]
    }
  },
  async created() {
    await this.listTasks();
  },
  computed: {
    ...mapGetters(['tasks']),
    tableItems(){
      if (this.tasks) {
        return this.tasks.map((t) => {
          return {
            'Nombre': t.name,
            'Responsable': t.responsableCollaborator.name +' '+ t.responsableCollaborator.lastName,
            'Día de vencimiento': t.expirationDate,
            'Acciones': { task: t }
          }
        })
      }
      return [];
    },
  },
  methods: {
    ...mapActions(['listTasks']),
    showCreateModal() {
      this.showCreate = true;
    },
    showDeleteModal(task){
      this.selectedTask = task;
      this.showDelete = true;
    },
    showEditModal(task){
      this.selectedTask = task;
      this.showEdit = true;
    },
    async hideCreateModal() {
      this.showCreate = false;
      await this.listTasks();
    },
    async hideDeleteModal() {
      this.showDelete = false;
      await this.listTasks();
    },
    async hideEditModal() {
      this.showEdit = false;
      await this.listTasks();
    },
    makeToast(variant=null, body, title) {
      this.$bvToast.toast(
        body,
        {
          title,
          variant,
          solid: true,
          hide: true,
          autoHideDelay: 3000
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
#tasks-list {
  margin-top: 20px;
  #addButton {
    margin-bottom: 20px;
  }
  .tableButton {
    margin-right: 5px;
  }
}
</style>